import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { CompanyQueryKey } from './queryKey';
export const useGetCompanies = () => {
    const intl = useIntl();
    return useQuery([CompanyQueryKey.Companies], () => api.base.get('/api/company/GetAll').then(res => res.data), {
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
